import {
  AD_ACTIVITY_DATA,
  AD_COPY_DATA,
  BRANDS_INSIGHTS_ACTIVE_TAB,
  CLEAR_ALL_FILTERS,
  HEADLINES_DATA,
  HOOKS_DATA,
  LANDING_PAGES_DATA,
  MEDIA_MIX_DATA,
  METRICS_DATA,
} from '@utils/constants'
import { useDispatch } from 'react-redux'

export const applyFilters = (data, advancedFilters) => {
  if (!data) return []

  const currentTime = new Date()

  return data.filter(item => {
    const isActive =
      item?.additional_info?.is_active === true || item?.additional_info?.is_active === 'true'
    const adCreationTime = item?.additional_info?.ad_creation_time
    const creationTime = new Date(adCreationTime)
    const daysDiff = Math.floor((currentTime - creationTime) / (1000 * 60 * 60 * 24))
    const adPerformance = item?.additional_info?.ai_performance
    const adIndustry = item?.additional_info?.industry
    const adLanguage = item?.languages
    const title = Array.isArray(item?.title) ? item.title[0] : item?.title
    const adHooks = title?.split('.')[0] || ''
    const adDescriptions = item?.description || ''
    const adHeadlines = title || ''
    const adLandingPages = item?.additional_info?.ad_link || ''

    let platformMatch = true
    let industryMatch = true
    let performanceMatch = true
    let adIndustryMatch = true
    let languageMatch = true
    let headlinesMatch = true
    let descriptionsMatch = true
    let hooksMatch = true
    let landingPagesMatch = true

    // ✅ Platform Filter
    if (
      advancedFilters.platform &&
      advancedFilters.platform.length > 0 &&
      advancedFilters.platform.length !== 2
    ) {
      platformMatch = advancedFilters.platform.includes('active') ? isActive : !isActive
    }

    // ✅ Industry Filter (Time Range Logic)
    if (advancedFilters?.industry?.length > 0) {
      const selectedTimeRange = advancedFilters.industry[0]
      switch (selectedTimeRange) {
        case 'Under 7 Days':
          industryMatch = daysDiff < 7
          break
        case 'Over 7 Days':
          industryMatch = daysDiff >= 7
          break
        case 'Over 15 Days':
          industryMatch = daysDiff >= 15
          break
        case 'Over 30 Days':
          industryMatch = daysDiff >= 30
          break
        case 'Over 3 Months':
          industryMatch = daysDiff >= 90
          break
        case 'Over 6 Months':
          industryMatch = daysDiff >= 180
          break
        case 'Over 12 Months':
          industryMatch = daysDiff >= 365
          break
        default:
          industryMatch = true
      }
    }

    // ✅ Performance Filter
    if (advancedFilters?.performance?.length > 0) {
      performanceMatch = advancedFilters.performance.includes(adPerformance)
    }

    // ✅ Ad Industry Filter
    if (advancedFilters?.adIndustry?.length > 0) {
      adIndustryMatch = advancedFilters.adIndustry.includes(adIndustry)
    }

    // ✅ Language Filter
    if (advancedFilters?.language?.length > 0) {
      if (Array.isArray(adLanguage)) {
        languageMatch = adLanguage.some(lang => advancedFilters.language.includes(lang))
      } else {
        languageMatch = advancedFilters.language.includes(adLanguage)
      }
    }

    // ✅ Headlines Filter (partial match)
    if (advancedFilters?.headlines?.length > 0) {
      headlinesMatch = advancedFilters.headlines.some(headline =>
        adHeadlines.toLowerCase().includes(headline.toLowerCase())
      )
    }

    // ✅ Descriptions Filter (exact match)
    if (advancedFilters?.descriptions?.length > 0) {
      descriptionsMatch = advancedFilters?.descriptions.includes(adDescriptions)
    }

    // ✅ Hooks Filter (partial match)
    if (advancedFilters?.hooks?.length > 0) {
      hooksMatch = advancedFilters.hooks.some(hook =>
        adHooks.toLowerCase().includes(hook.toLowerCase())
      )
    }

    // ✅ Landing Pages Filter (partial match)
    if (advancedFilters?.landingPages?.length > 0) {
      landingPagesMatch = advancedFilters.landingPages.some(page =>
        adLandingPages.toLowerCase().includes(page.toLowerCase())
      )
    }

    return (
      platformMatch &&
      industryMatch &&
      performanceMatch &&
      adIndustryMatch &&
      languageMatch &&
      headlinesMatch &&
      descriptionsMatch &&
      hooksMatch &&
      landingPagesMatch
    )
  })
}

// eslint-disable-next-line
export const applyRunTimeFilter = data => {
  const currentTime = new Date()
  const creationTime = new Date(data)
  const daysDiff = Math.floor((currentTime - creationTime) / (1000 * 60 * 60 * 24))
  if (daysDiff < 7) {
    return 'Under 7 days'
  } // eslint-disable-next-line
  else if (daysDiff < 15) {
    return 'Over 7 days'
  } else if (daysDiff < 30) {
    return 'Over 15 days'
  } else if (daysDiff < 90) {
    return 'Over 30 days'
  } else if (daysDiff < 180) {
    return 'Over 3 months'
  } else if (daysDiff < 365) {
    return 'Over 6 months'
  } else {
    return 'Over 12 months'
  }
}

export const clearAllFiltersData = async dispatch => {
  dispatch({ type: CLEAR_ALL_FILTERS, payload: true })
  dispatch({ type: BRANDS_INSIGHTS_ACTIVE_TAB, payload: 'overview' })
  dispatch({ type: METRICS_DATA, payload: [] })
  dispatch({ type: AD_ACTIVITY_DATA, payload: [] })
  dispatch({ type: AD_COPY_DATA, payload: [] })
  dispatch({ type: HEADLINES_DATA, payload: [] })
  dispatch({ type: LANDING_PAGES_DATA, payload: [] })
  dispatch({ type: MEDIA_MIX_DATA, payload: [] })
  dispatch({ type: HOOKS_DATA, payload: [] })

  // All dispatches done
  return Promise.resolve() // Just to make the function truly "awaitable"
}
